import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

function ContactForm() {
    const [state, handleSubmit] = useForm("mqkrrjak");
    if (state.succeeded) {
        return <p>We will get back to you shortly!</p>;
    }
    return (

        <div className="col-xl-4 col-lg-6 col-md-6 m-md-b30 m-lg-b30">
            <div className="p-a30 bg-gray clearfix radius-sm contact-form-box">
                <h3 className="m-b20">Send Message Us</h3>
                <div className="dzFormMsg"></div>
                <form className="dzForm" onSubmit={handleSubmit}>
                    <input type="hidden" value="Contact" name="dzToDo" />
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label>Name</label>
                                <div className="input-group">
                                    <input name="Name" type="text" id='name' required className="form-control" placeholder="Your Name" />
                                    <ValidationError id="name" type="text" />
                                </div>
                            </div>
                        </div>
	     <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor="email">
                                    Phone Number
                                </label>
                                <div className="input-group">
                                    <input name="tel" id="tel" type="tel" className="form-control" required placeholder="Your Mobile number" />
                                    <ValidationError
                                        prefix="tel"
                                        field="tel"
                                        errors={state.errors}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label htmlFor="email">
                                    Email Address
                                </label>
                                <div className="input-group">
                                    <input name="email" id="email" type="email" className="form-control" required placeholder="Your Email Id" />
                                    <ValidationError
                                        prefix="Email"
                                        field="email"
                                        errors={state.errors}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label>Message</label>
                                <div className="input-group">
                                    <textarea name="message" id="message" rows="4" className="form-control" required placeholder="Your Message..."></textarea>
                                    <ValidationError
                                        prefix="Message"
                                        field="message"
                                        errors={state.errors}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
													<button name="submit" type="submit" value="Submit" className="btn btnhover" disabled={state.submitting}> <span>Submit</span> </button>
												</div>
                    </div>
                </form>
            </div>
        </div>

    );
}

export default ContactForm;
